import React from 'react';
import ReactDOM from 'react-dom';
import * as serviceWorker from './serviceWorker';
import { BrowserRouter, Route } from 'react-router-dom';

import Directory from './components/Directory/Directory';
import List from './components/Map/List';
import Layout from './components/Carta/Layout';
import Cards from './components/Carta/Cards';

import Login from './components/Login'


var idCompany = -1;
if(window.sessionCompany.idCompany !== null && window.sessionCompany.idCompany !== ''){
    idCompany = parseInt(window.sessionCompany.idCompany);
}

var idDirectory = -2;
if(window.sessionDirectory.idDirectory !== null && window.sessionDirectory.idDirectory !== ''){
    idDirectory = parseInt(window.sessionDirectory.idDirectory);
}

var idMenu = -1;
if(window.sessionMenu.idMenu !== null && window.sessionMenu.idMenu !== ''){
    idMenu = parseInt(window.sessionMenu.idMenu);
}

/*
var idCompany = window.sessionCompany.idCompany;
var idDirectory = window.sessionDirectory.idDirectory;
var idMenu = window.sessionMenu.idMenu;
*/

console.log("idDirectory: ", idDirectory);
console.log("idCompany: ",  idCompany);
console.log("idMenu: ",  idMenu);
//  anterior   {idDirectory === -1 ? <Route path="/" component={List}/> : <Route exact path="/" component={List}/>}

 var Rutas = () => (
        <BrowserRouter>
          <React.Fragment>

        {(() => {
            if(idMenu > 0){
                console.log("-- idDirectory === -1 --");
                return(
                    <Route path="/" component={Layout}/>
                )
            } else  if(idDirectory > 0 || idCompany > 0){
                  console.log("-- idDirectory > 0 || idCompany > 0 --");
                  return(
                      <Route path="/" component={Directory}/>
                  )
              } else {
                  console.log("-- ELSE -> idDirectory > 0 || idCompany > 0  ");
                  return(
                      <Route path="/" component={List}/>
                  )
              }
           })()}

          </React.Fragment>
        </BrowserRouter>
    )




ReactDOM.render(
  <React.Fragment>
    <Rutas />
  </React.Fragment>,
  document.getElementById('root'));


// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
